import { ObjectValuesUnionType } from '../utils/typing';

export const BonusQueues = Object.freeze({
  PRIMARY: 'PRIMARY',
  BETTING: 'BETTING',
  POKER: 'POKER',
  VIP: 'VIP',
});
export type BonusQueue = ObjectValuesUnionType<typeof BonusQueues>;

export const BonusTypes = Object.freeze({
  CASH: 'CASH',
  FREEBET: 'FREEBET',
  TICKETS: 'TICKETS',
});
export type BonusType = ObjectValuesUnionType<typeof BonusTypes>;

export const BonusStatuses = Object.freeze({
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
});
export type BonusStatus = ObjectValuesUnionType<typeof BonusStatuses>;
